<template>
    <div class="review-container">

        <!-- 页面头部 -->
        <div class="page-header">
            <div class="page-header-left">
                <el-button icon="el-icon-arrow-left" size="small" @click="close('/DataProperty')">返回</el-button>
                <span class="page-title">数据资产详情</span>
            </div>
            <span class="registration-id" v-if="registrationId">登记编号：{{ registrationId }}</span>
        </div>

        <!-- 基本信息 -->
        <el-card class="detail-card">
            <div slot="header" class="card-header">
                <i class="el-icon-document card-header-icon" />
                <span>基本信息</span>
            </div>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="数据资产名称" :span="2">{{ formData.assetName }}</el-descriptions-item>
                <el-descriptions-item label="数据来源">{{ formData.dataSource }}</el-descriptions-item>
                <el-descriptions-item label="所属行业">{{ formData.industry }}</el-descriptions-item>
                <el-descriptions-item label="数据类型">{{ formData.dataType }}</el-descriptions-item>
                <el-descriptions-item label="数据覆盖地域">{{ formData.region }}</el-descriptions-item>
                <el-descriptions-item label="应用场景描述" :span="2">{{ formData.scenario }}</el-descriptions-item>
                <el-descriptions-item label="数据资产简介" :span="2">{{ formData.description }}</el-descriptions-item>
            </el-descriptions>
        </el-card>

        <!-- 数据属性 -->
        <el-card class="detail-card">
            <div slot="header" class="card-header">
                <i class="el-icon-data-analysis card-header-icon" />
                <span>数据属性</span>
            </div>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="数据结构">{{ formData.dataScaleType }}</el-descriptions-item>
                <el-descriptions-item label="更新周期">{{ formData.updateCycle }}</el-descriptions-item>
                <el-descriptions-item
                    v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                    label="存储空间">{{ formData.storageUnit }}</el-descriptions-item>
                <el-descriptions-item
                    v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                    label="数据规模">{{ formData.contactName }}</el-descriptions-item>
                <el-descriptions-item
                    v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '非结构化数据'"
                    label="文件数量">{{ formData.fieldCount }}</el-descriptions-item>
                <el-descriptions-item label="数据期间">{{ formData.creator }}</el-descriptions-item>
            </el-descriptions>
        </el-card>

        <!-- 产权信息 -->
        <el-card class="detail-card">
            <div slot="header" class="card-header">
                <i class="el-icon-office-building card-header-icon" />
                <span>产权信息</span>
            </div>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="权利类型">{{ formData.rightsType }}</el-descriptions-item>
                <el-descriptions-item label="产权期限">{{ formData.updater }}</el-descriptions-item>
                <el-descriptions-item label="使用限制" :span="2">{{ formData.usageLimit }}</el-descriptions-item>
            </el-descriptions>
        </el-card>

        <!-- 合规材料 -->
        <el-card class="detail-card">
            <div slot="header" class="card-header">
                <i class="el-icon-folder card-header-icon" />
                <span>合规材料</span>
            </div>
            <el-descriptions :column="1" border>
                <el-descriptions-item label="数据样本材料">
                    <template v-if="complianceData.dataSampleMaterials">
                        <div v-for="(file, index) in splitFiles(complianceData.dataSampleMaterials)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ file }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(file)" type="text" size="mini" icon="el-icon-view" @click="previewComplianceFile(file)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadComplianceFile(file)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="数据来源材料">
                    <template v-if="complianceData.dataSourceMaterials">
                        <div v-for="(file, index) in splitFiles(complianceData.dataSourceMaterials)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ file }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(file)" type="text" size="mini" icon="el-icon-view" @click="previewComplianceFile(file)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadComplianceFile(file)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="数据存储材料">
                    <template v-if="complianceData.dataStorageMaterials">
                        <div v-for="(file, index) in splitFiles(complianceData.dataStorageMaterials)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ file }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(file)" type="text" size="mini" icon="el-icon-view" @click="previewComplianceFile(file)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadComplianceFile(file)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="资质材料">
                    <template v-if="complianceData.qualificationMaterials">
                        <div v-for="(file, index) in splitFiles(complianceData.qualificationMaterials)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ file }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(file)" type="text" size="mini" icon="el-icon-view" @click="previewComplianceFile(file)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadComplianceFile(file)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>

        <!-- 证明材料 -->
        <el-card class="detail-card">
            <div slot="header" class="card-header">
                <i class="el-icon-files card-header-icon" />
                <span>证明材料</span>
            </div>
            <el-descriptions :column="1" border>
                <el-descriptions-item label="数据资产查验报告">
                    <template v-if="splitStringByComma(formData.reportFile).length">
                        <div v-for="(item, index) in splitStringByComma(formData.reportFile)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ item }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" icon="el-icon-view" @click="previewFile(item)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="数据资产查验详情表">
                    <template v-if="splitStringByComma(formData.verificationFile).length">
                        <div v-for="(item, index) in splitStringByComma(formData.verificationFile)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ item }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" icon="el-icon-view" @click="previewFile(item)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="数据资产登记承诺书">
                    <template v-if="splitStringByComma(formData.commitmentFile).length">
                        <div v-for="(item, index) in splitStringByComma(formData.commitmentFile)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ item }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" icon="el-icon-view" @click="previewFile(item)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
                <el-descriptions-item label="其他材料">
                    <template v-if="splitStringByComma(formData.otherFile).length">
                        <div v-for="(item, index) in splitStringByComma(formData.otherFile)" :key="index" class="file-item">
                            <i class="el-icon-paperclip file-icon" />
                            <span class="file-name">{{ item }}</span>
                            <div class="file-actions">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" icon="el-icon-view" @click="previewFile(item)">预览</el-button>
                                <el-button type="text" size="mini" icon="el-icon-download" @click="downloadFile(item)">下载</el-button>
                            </div>
                        </div>
                    </template>
                    <span v-else class="empty-text">无</span>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>

        <!-- 登记证书（已颁发证书状态显示） -->
        <el-card class="detail-card" v-if="formData.state === '已颁发证书'">
            <div slot="header" class="card-header">
                <i class="el-icon-medal card-header-icon" />
                <span>登记证书</span>
            </div>
            <div class="certificate-section">
                <div class="certificate-preview" @click="downloadCertificate">
                    <img src="@/assets/img/pdf-icon.png" alt="证书预览" class="cert-thumb" />
                    <div class="cert-overlay"><i class="el-icon-download" /> 点击下载</div>
                </div>
                <div class="certificate-info">
                    <div class="cert-filename">
                        <i class="el-icon-document cert-file-icon" />
                        <span>{{ formData.certificateFile }}</span>
                    </div>
                    <el-button type="primary" size="small" icon="el-icon-download" @click="downloadCertificate">下载证书</el-button>
                </div>
            </div>
        </el-card>

        <!-- 底部操作 -->
        <div class="footer-actions">
            <el-button size="medium" icon="el-icon-close" @click="close('/DataCompliance')">关闭</el-button>
        </div>

        <file-preview ref="filePreview" download-base-url="/web/file/download" />
        <file-preview ref="complianceFilePreview" download-base-url="/web/dataComplianceDetail/download"
            :custom-params="filePreviewParams" />
    </div>
</template>

<script>
import FilePreview from '@/components/FilePreview.vue';
export default {
    name: "ReviewPage",
    components: {
        FilePreview
    },
    data() {
        return {
            activeTab: 'review',
            registrationId: '',
            formData: {
                // 主体信息字段
                companyName: '',
                socialCreditCode: '',
                contactsName: '',
                contactsPhone: '',

                // 资产信息字段
                platformName: '',
                assetName: '',
                dataSource: '',
                industry: '',
                dataType: '',
                region: '',
                dataScaleType: '',
                storageUnit: '',
                contactName: '',
                fieldCount: '',
                creator: '',
                updater: '',
                dataPeriod: '',
                updateCycle: '',
                rightsType: '',
                rightsPeriod: '',
                usageLimit: '',
                scenario: '',
                description: '',

                // 证明材料字段
                reportFile: [],
                verificationFile: [],
                commitmentFile: [],
                otherFile: []
            },
            auditCriteria1: null,
            auditCriteria2: null,
            auditCriteria3: null,
            auditCriteria4: null,
            auditCriteria5: null,
            reviewComment: '',
            allStandardsPassed: false,
            complianceData: {
                dataSampleMaterials: '',
                dataSourceMaterials: '',
                dataStorageMaterials: '',
                qualificationMaterials: ''
            },
                        // 文件预览组件的参数
            filePreviewParams: {},
        }
    },
    created() {
        this.registrationId = this.$route.query.registrationId;
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                // 获取主体信息
                const companyInfo = await this.getRequest('/web/companyInfo/queryByRegistrationId?registrationId=' + this.registrationId,);

                // 获取资产信息
                const assetInfo = await this.getRequest('/web/dataAssets/queryForReview?registrationId=' + this.registrationId,);

                if (companyInfo && companyInfo.status === 200 && assetInfo && assetInfo.status === 200) {
                    this.formData = {
                        ...companyInfo.data,
                        ...assetInfo.data
                    };

                    // 如果已颁发证书，获取证书文件信息
                    if (assetInfo.data.state === '已颁发证书') {
                        this.formData.certificateFile = this.registrationId + ".pdf";
                        //  const certInfo = await this.$axios.get('/web/certificate/queryByRegistrationId?registrationId=' + this.registrationId);
                        //  if (certInfo && certInfo.status === 200) {
                        //     this.formData.certificateFile = certInfo.data.certificateFile;
                        //  }
                    }
                }


                const response = await this.getRequest(`/web/dataAssets/queryReview?registrationId=${this.registrationId}`);
                console.log('合规信息:', response);
                // 将合规材料数据赋值到 complianceData
                if (response.data && response.data.compliance) {
                    this.complianceData = {
                        dataSampleMaterials: response.data.compliance.dataSampleMaterials || '',
                        dataSourceMaterials: response.data.compliance.dataSourceMaterials || '',
                        dataStorageMaterials: response.data.compliance.dataStorageMaterials || '',
                        qualificationMaterials: response.data.compliance.qualificationMaterials || ''
                    };
                }



            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
            }
        },
                // 预览合规材料文件
        async previewComplianceFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            try {
                await this.$refs.complianceFilePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('合规材料预览失败:', error);
                this.$message.error('合规材料预览失败: ' + (error.message || ''));
            }
        },

        // 下载合规材料文件
        async downloadComplianceFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataComplianceDetail/download?registrationId=' + this.registrationId + '&fileName=' + filename,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('合规材料下载失败:', error);
                this.$message.error('合规材料下载失败: 文件不存在或已删除！' );
            }
        },

        // 分割逗号分隔的文件字符串
        splitFiles(fileString) {
            if (!fileString) return [];
            return fileString.split(',').map(file => file.trim());
        },
                // 设置文件预览参数
        setFilePreviewParams() {
            this.filePreviewParams = {
                registrationId: this.registrationId,
                userId: this.formData.userId
            };
        },

        // 将字符串按逗号分隔为数组
        splitStringByComma(str) {
            if (!str) {
                return [];
            }

            // 确保输入是字符串类型
            const strValue = String(str);

            // 按逗号分隔，去除每个元素的前后空格，并过滤掉空字符串
            return strValue.split(',')
                .map(item => item.trim())
                .filter(item => item.length > 0);
        },

        // 判断文件是否可以预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },
        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },
        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },


        handleApprove() {
            this.$confirm('确认审核通过该数据资产?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/web/dataAssets/approve/pass', {
                    registrationId: this.registrationId,
                    auditCriteria1: this.auditCriteria1,
                    auditCriteria2: this.auditCriteria2,
                    auditCriteria3: this.auditCriteria3,
                    auditCriteria4: this.auditCriteria4,
                    auditCriteria5: this.auditCriteria5,
                    reviewComment: this.reviewComment
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('审核通过成功');
                        this.$router.go(-1);
                    }
                });
            });
        },
        handleReject() {
            this.$confirm('确认驳回该数据资产?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/web/dataAssets/approve/rejected', {
                    registrationId: this.registrationId,
                    auditCriteria1: this.auditCriteria1,
                    auditCriteria2: this.auditCriteria2,
                    auditCriteria3: this.auditCriteria3,
                    auditCriteria4: this.auditCriteria4,
                    auditCriteria5: this.auditCriteria5,
                    reviewComment: this.reviewComment
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('驳回成功');
                        this.$router.go(-1);
                    }
                });
            });
        },
        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/file/download/' + filename,
                    params: { registrationId: this.registrationId },
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        async downloadCertificate() {
            if (!this.formData.certificateFile) {
                this.$message.warning('证书文件不存在');
                return;
            }

            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/certificate/download',
                    params: {
                        registrationId: this.registrationId,
                        filename: this.formData.certificateFile
                    },
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.formData.certificateFile);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('证书下载失败:', error);
                this.$message.error('证书下载失败: ' + error.message);
            }
        },

        // 关闭组件
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },
    }
}
</script>

<style scoped>
.review-container {
    padding: 20px 30px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 40px);
}

/* 页面头部 */
.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 14px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.page-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.page-title {
    font-size: 17px;
    font-weight: 600;
    color: #303133;
}

.registration-id {
    font-size: 13px;
    color: #909399;
}

/* 卡片 */
.detail-card {
    margin-bottom: 16px;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.detail-card >>> .el-card__header {
    padding: 0;
    border-bottom: 1px solid #ebeef5;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: #f8f9fb;
    font-size: 15px;
    font-weight: 600;
    color: #303133;
}

.card-header-icon {
    color: #409EFF;
    font-size: 16px;
}

/* descriptions 标签列样式 */
.detail-card >>> .el-descriptions-item__label {
    font-size: 13px;
    color: #606266;
    background-color: #fafafa;
    width: 160px;
    font-weight: 500;
}

.detail-card >>> .el-descriptions-item__content {
    font-size: 13px;
    color: #303133;
}

/* 文件项 */
.file-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    margin-bottom: 4px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
}

.file-icon {
    color: #409EFF;
    flex-shrink: 0;
}

.file-name {
    flex: 1;
    font-size: 13px;
    color: #303133;
    word-break: break-all;
}

.file-actions {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
}

.empty-text {
    color: #c0c4cc;
    font-size: 13px;
}

/* 证书区域 */
.certificate-section {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    padding: 16px;
}

.certificate-preview {
    position: relative;
    cursor: pointer;
    width: 120px;
    flex-shrink: 0;
}

.cert-thumb {
    width: 120px;
    height: 135px;
    border: 1px solid #ddd;
    border-radius: 6px;
    display: block;
    transition: opacity 0.2s;
}

.cert-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    opacity: 0;
    transition: opacity 0.2s;
}

.certificate-preview:hover .cert-overlay {
    opacity: 1;
}

.certificate-preview:hover .cert-thumb {
    opacity: 0.85;
}

.certificate-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
}

.cert-filename {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #606266;
}

.cert-file-icon {
    color: #F56C6C;
    font-size: 18px;
}

/* 底部操作 */
.footer-actions {
    margin-top: 24px;
    text-align: center;
    padding-bottom: 20px;
}
</style>